import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.977 4.951a44.7 44.7 0 0 0-10.48-3.182 1.57 1.57 0 0 0-1.76 1.014l-5.374 2.71a2 2 0 0 0-1.399-.581A1.964 1.964 0 0 0 1 6.876v15.32a.785.785 0 0 0 .786.786h2.357a.785.785 0 0 0 .785-.786V7.756l4.824 2.435c.088.246.24.463.44.629.285.243.647.377 1.021.377q.138.012.276 0a44.7 44.7 0 0 0 10.496-3.143 1.658 1.658 0 0 0 0-3.056zm-4.478-.04v3.143q-1.163.393-2.357.708V4.22q1.178.328 2.357.692M9.642 8.378l-2.2-1.108h2.2zm0-3.764v1.084H7.474zm-7.07 2.263a.393.393 0 0 1 .785 0V8.84h-.786zm.785 14.535h-.786v-11h.786zm7.856-11.785V3.34q1.179.209 2.358.479v5.334q-1.164.283-2.357.472m10.128-3.049c-.747.33-1.5.637-2.27.92V5.47c.785.282 1.531.589 2.285.927.071.023.071.086.071.086s0 .063-.086.094"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.07 11.197a2.36 2.36 0 0 0-2.043 1.179.786.786 0 0 0 .885 1.15c.2-.054.371-.185.475-.365a.785.785 0 1 1 .683 1.179h-6.285a.786.786 0 0 0 0 1.571h6.285a2.357 2.357 0 0 0 0-4.714M14.356 16.697H8.071a.786.786 0 0 0 0 1.571h6.285a.786.786 0 1 0 0-1.571"
    }, null, -1)
  ]))]))
}
export default { render: render }